<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'CONFIG.PAGE_TITLE' | transloco }}</ion-title>

    <ion-buttons slot="start">
      <ion-menu-button appMenuNotificationDot></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-segment [(ngModel)]="selectedTab">
    @for (tab of (visibleTabs$ | async); track tab) {
    <ion-segment-button [value]="tab.toString()">{{ tabLabels[tab] | transloco }}</ion-segment-button>
    }
  </ion-segment>

  <form [formGroup]="form">
    @if (selectedTab === ConfigTabType.Obecne) {
    <div>
      <ion-list>
        <ion-item-divider>
          <ion-label>{{ 'CONFIG.ASSISTANT_LIST_SECTION' | transloco }}</ion-label>
        </ion-item-divider>
        <ion-item>
          <ion-label>{{ 'CONFIG.ASSISTANT_LIST_CUSTOM_COLUMNS' | transloco }}</ion-label>
          <div class="align-end">
            <app-column-select
              [formControlName]="configKeys.ASSISTANT_LIST_CUSTOM_COLUMNS"
              [value]="configuredCustomColumns.assistantList | async"
              [columns]="availableCustomColumns.assistantList"
              [allowEmpty]="false"
            ></app-column-select>
          </div>
        </ion-item>
      </ion-list>
      <ion-list>
        <ion-item-divider>
          <ion-label>{{ 'CONFIG.ORGANIZATION_DATA_SECTION' | transloco }}</ion-label>
        </ion-item-divider>
        <ion-item>
          <ion-label>{{ 'CONFIG.ORGANIZATION_NAME' | transloco }}</ion-label>
          <ion-input [formControlName]="configKeys.ORGANIZACE_NAZEV"></ion-input>
        </ion-item>
        <ion-item class="row">
          <ion-label>{{ 'CONFIG.LOGO' | transloco }}</ion-label>
          <div class="align-end">
            <input type="file" #logoInput (change)="onLogoFileChange($event)" accept="image/*" hidden />
            @if (logo.base64) {
            <div class="logo-preview-wrapper">
              <img [src]="logo.base64" alt="Logo Preview" class="logo-preview" (click)="logoInput.click()" />
              <ion-icon name="close-circle" class="remove-logo-icon" (click)="removeLogo()"></ion-icon>
            </div>
            } @if (!logo.base64) {
            <ion-button (click)="logoInput.click()" style="margin-top: 5px">
              {{ 'CONFIG.SELECT_IMAGE' | transloco }}
            </ion-button>
            } @if (form.get('logoFileControl').errors?.logoError) {
            <div style="margin-top: 5px">
              <p style="color: red">{{ form.get('logoFileControl').errors.logoError }}</p>
            </div>
            }
          </div>
        </ion-item>
        <ion-item>
          <ion-label>{{ 'CONFIG.ORGANIZATION_ADDRESS' | transloco }}</ion-label>
          <ion-input [formControlName]="configKeys.ORGANIZACE_ADRESA_SIDLA"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label>{{ 'CONFIG.ORGANIZATION_ID_NUMBER' | transloco }}</ion-label>
          <ion-input [formControlName]="configKeys.ORGANIZACE_ICO"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label>{{ 'CONFIG.ORGANIZATION_PHONE' | transloco }}</ion-label>
          <ion-input [formControlName]="configKeys.ORGANIZACE_TELEFON"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label>{{ 'CONFIG.ORGANIZATION_BANK_ACCOUNT_NUMBER' | transloco }}</ion-label>
          <ion-input [formControlName]="configKeys.ORGANIZACE_CISLO_UCTU"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label>{{ 'CONFIG.ORGANIZATION_BANK_NAME' | transloco }}</ion-label>
          <ion-input [formControlName]="configKeys.ORGANIZACE_BANKA"></ion-input>
        </ion-item>
      </ion-list>
    </div>
    } @if (selectedTab === ConfigTabType.OA.toString()) {
    <div>
      <fieldset>
        <legend>
          <ion-label>{{ 'CONFIG.COORDINATOR_HOURS_SECTION' | transloco }}</ion-label>
        </legend>
        <ion-item>
          {{ 'CONFIG.COORDINATOR_HOURS_WEEKDAYS' | transloco }}
          <ejs-timepicker
            slot="end"
            [formControlName]="configKeys.ORDINACNI_HODINY_START_NO_TZ"
            [value]="configs[configKeys.ORDINACNI_HODINY_START_NO_TZ]"
          ></ejs-timepicker>
          <span slot="end">-</span>
          <ejs-timepicker
            slot="end"
            [formControlName]="configKeys.ORDINACNI_HODINY_END_NO_TZ"
            [value]="configs[configKeys.ORDINACNI_HODINY_END_NO_TZ]"
          ></ejs-timepicker>
        </ion-item>
      </fieldset>
      <fieldset>
        <legend>
          <ion-label>{{ 'CONFIG.LATE_ASSISTANCE_SECTION' | transloco }}</ion-label>
        </legend>
        <ion-item>
          {{ 'CONFIG.LATE_ASSISTANCE_HOURS' | transloco }}
          <ion-input
            slot="end"
            type="number"
            [formControlName]="configKeys.ODKDY_JE_POZDE_OBJEDNANA_ASISTENCE_HODINY"
            [value]="configs[configKeys.ODKDY_JE_POZDE_OBJEDNANA_ASISTENCE_HODINY]"
          ></ion-input>
          <ejs-tooltip
            slot="end"
            id="tooltip"
            [content]="tooltipTexts[configKeys.ODKDY_JE_POZDE_OBJEDNANA_ASISTENCE_HODINY]"
          >
            <ion-icon name="help-circle"></ion-icon>
          </ejs-tooltip>
        </ion-item>
        <ion-item>
          {{ 'CONFIG.LATE_ASSISTANCE_APPLIES_TO_COORDINATORS' | transloco }}
          <ion-checkbox
            slot="end"
            [formControlName]="configKeys.POZDE_OBJEDNANA_JESTLI_SE_VZTAHUJE_NA_KOORDINATORY"
          ></ion-checkbox>
          <ejs-tooltip
            slot="end"
            id="tooltip2"
            [content]="tooltipTexts[configKeys.POZDE_OBJEDNANA_JESTLI_SE_VZTAHUJE_NA_KOORDINATORY]"
          >
            <ion-icon name="help-circle"></ion-icon>
          </ejs-tooltip>
        </ion-item>
      </fieldset>
      <fieldset>
        <legend>
          <ion-label>{{ 'CONFIG.CANCEL_SECTION' | transloco }}</ion-label>
        </legend>
        <ion-item>
          {{ 'CONFIG.CANCEL_HOURS_BEFORE' | transloco }}
          <ion-input
            slot="end"
            type="number"
            [formControlName]="configKeys.ODKDY_JE_POZDE_ZRUSENA_JIZ_POTVRZENA_ASISTENCE_HODINY"
            [value]="configs[configKeys.ODKDY_JE_POZDE_ZRUSENA_JIZ_POTVRZENA_ASISTENCE_HODINY]"
          ></ion-input>
        </ion-item>
        <ion-item>
          {{ 'CONFIG.CANCEL_WORKING_DAYS_ONLY' | transloco }}
          <ion-checkbox
            slot="end"
            [formControlName]="configKeys.STORNO_BEZ_LIMITU_O_VIKENDECH_A_SVATCICH"
          ></ion-checkbox>
        </ion-item>
        <ion-item>
          <ion-label>{{ 'CONFIG.CLIENT_CANCEL_FEE_MODE' | transloco }}</ion-label>
          <p-select
            slot="end"
            [formControlName]="configKeys.CLIENT_CANCEL_FEE_MODE"
            [options]="cancelFeeModeOptions"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'CONFIG.CLIENT_CANCEL_FEE_MODE_PLACEHOLDER' | transloco"
            appendTo="body"
          ></p-select>
        </ion-item>
      </fieldset>
      <fieldset>
        <legend>
          <ion-label>{{ 'CONFIG.EDIT_PAST_EVENTS_SECTION' | transloco }}</ion-label>
        </legend>
        <ion-item>
          {{ 'CONFIG.EDIT_PAST_ASSISTANCE_DAYS' | transloco }}
          <ion-input
            slot="end"
            type="number"
            [formControlName]="configKeys.DOKDY_JE_MOZNA_EDITACE_PROBEHLYCH_ASISTENCI_DNY"
            [value]="configs[configKeys.DOKDY_JE_MOZNA_EDITACE_PROBEHLYCH_ASISTENCI_DNY]"
          ></ion-input>
        </ion-item>
      </fieldset>
      <fieldset>
        <legend>
          <ion-label>{{ 'CONFIG.TRAVEL_SECTION' | transloco }}</ion-label>
        </legend>
        <ion-item>
          {{ 'CONFIG.DEFAULT_TRAVEL_TIME' | transloco }}
          <ion-input
            slot="end"
            type="number"
            [formControlName]="configKeys.VYCHOZI_DOBA_PREJEZDU_MINUTY"
            [value]="configs[configKeys.VYCHOZI_DOBA_PREJEZDU_MINUTY]"
          ></ion-input>
          <div slot="end">{{ 'CONFIG.MINUTES' | transloco }}</div>
        </ion-item>
      </fieldset>
      <fieldset>
        <legend>
          <ion-label>{{ 'CONFIG.JOURNAL_ENTRY_HISTORY_TITLE' | transloco }}</ion-label>
        </legend>
        <ion-item>
          {{ 'CONFIG.JOURNAL_ENTRY_HISTORY_SHOW_HISTORY' | transloco }}
          <ion-checkbox slot="end" [formControlName]="configKeys.JOURNAL_ENTRY_HISTORY_ENABLED"></ion-checkbox>
        </ion-item>
      </fieldset>
    </div>
    } @if (selectedTab === ConfigTabType.PS.toString()) {
    <div>
      <!-- PS tab content -->
    </div>
    }
  </form>
</ion-content>
